export class SaleParameter {
    constructor(
        public initialDate: string,
        public finalDate: string,
        public searchedText: string | null,
        public policyType: string | null,
        public brokerID: string | null,
    ) { }
}